//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper";
import {
  getProfileDetail,
  postFakeLogin,
  postForgotPassword,
  postJwtLogin,
  postLogin,
  postResendPhoneOTP,
  postUpdatePassword,
  postVerifyPhoneOTP,
} from "../../../helpers/fakebackend_helper";

import { loginRequest, loginSuccess, logoutUserSuccess, apiError, reset_login_flag } from './reducer';
import { addPersistLoginInfo, addPersistUserInfo } from "../../PersistData/reducer";
import { showToast } from "../../../Components/ToastNotification";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { resetStore } from "../../../store";



// export const loginUser = (user, history) => async (dispatch) => {

//   try {
//     console.log("process.env.REACT_APP_API_BASE_URL",process.env.REACT_APP_API_BASE_URL)
//     let response;
//     if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
//       let fireBaseBackend = getFirebaseBackend();
//       response = fireBaseBackend.loginUser(
//         user.email,
//         user.password
//       );
//     } else if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
//       response = postJwtLogin({
//         email: user.email,
//         password: user.password
//       });

//     } else if (process.env.REACT_APP_API_BASE_URL) {
//       console.log("here")
//       response = postFakeLogin({
//         email: user.email,
//         password: user.password,
//       });
//     }
    
//     var data = await response;
//     console.log("data",data)
//     if (data) {
//       console.log("here")
//       sessionStorage.setItem("authUser", JSON.stringify(data));
//       if (process.env.REACT_APP_DEFAULTAUTH === "fake") {
//         console.log("here 2")
//         var finallogin = JSON.stringify(data);
//         finallogin = JSON.parse(finallogin)
//         data = finallogin.data;
//         if (finallogin.status === "success") {
//           dispatch(loginSuccess(data));
//           history('/dashboard')
//         } else {
//           dispatch(apiError(finallogin));
//         }
//       }else{
//         dispatch(loginSuccess(data));
//         history('/dashboard')
//       }
//     }
//   } catch (error) {
//     dispatch(apiError(error));
//   }
// };

export const loginUser = (user, history) => async (dispatch) => {
  try {
    // console.log(
    //   "process.env.REACT_APP_API_BASE_URL",
    //   process.env.REACT_APP_API_BASE_URL,
    //   user
    // );
    dispatch(loginRequest());
    let response;
    response = postLogin(user);

    var data = await response;
    // console.log("data", data);
    if (data?.code===200) {
      // console.log("here");
      sessionStorage.setItem("authUser", JSON.stringify(data));
      sessionStorage.setItem("welcomeModalShown", "true");
      dispatch(loginSuccess(response));
      // console.log("here 2");
      var finallogin = JSON.stringify(user);
      finallogin = JSON.parse(finallogin);
      data = finallogin.data;
      // console.log("data 2 final login", data, finallogin);
      // if (finallogin.status === "success") {
      //   dispatch(loginSuccess(data));
      //   showToast("Login successful","success")
      //   history('/dashboard')
      // } else {
      //   dispatch(apiError(finallogin));
      //   showToast("Invalid Credentials","error")
      // }
      // dispatch(loginSuccess(data));
      // dispatch(addPersistLoginInfo(data));
      // showToast("Login successful", "success");
      
      // history("/dashboard");
    }
    else{
      // showToast("Invalid Credentials", "error");
      dispatch(apiError(error));
    }
    return response;
  } catch (error) {
    dispatch(apiError(error));
    showToast(error, "error");
    return error;
  }
};

export const VerifyUser = ({user,token, history}) => async (dispatch) => {
  try {
    // console.log( "user, token",user,token);
    dispatch(loginRequest());
    let response;
    response = postVerifyPhoneOTP(user,token);

    var data = await response;
    // console.log("data", data);
    if (data?.code===200) {
      // console.log("here");
      sessionStorage.setItem("authUser", JSON.stringify(data));
      
      // console.log("here 2");
      
     
      dispatch(loginSuccess(data));
      dispatch(addPersistLoginInfo(data));
      showToast(data.message, "success");
      
      // history("/dashboard");
    }
    else{
      showToast(data.message, "error");
      dispatch(apiError(error));
    }
    return data;
  } catch (error) {
    dispatch(apiError(error));
    showToast(error, "error");
    return error;
  }
};

export const resendPhoneOtp = createAsyncThunk(
  "resendPhoneOtp",
  async (token) => {
    // const { phone, resend_type } = credentials;
    // console.log("credentials", credentials);

    try {
      let response;

      response = postResendPhoneOTP(token);

      // console.log("response", response);
      var data = await response;
      // console.log("Login", data);

      if (data.code == 200) {
        showToast(data.message, "success");
      } else {
        showToast(data.message, "error");
      }
      // navigate('/auth/verify/phone', { state: { redirectedfrom: 'login'} });
      return data;
    } catch (error) {
      // console.log("error", error);

      return error;
    }
  }
);

export const logoutUser = () => async (dispatch) => {
  try {
    sessionStorage.removeItem("authUser");
    let fireBaseBackend = getFirebaseBackend();
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const response = fireBaseBackend.logout;
      dispatch(logoutUserSuccess(response));
    } else {
      dispatch(logoutUserSuccess(true));
      resetStore();
      localStorage.removeItem('persist:root');
      sessionStorage.removeItem('persist:root');
    }

  } catch (error) {
    dispatch(apiError(error));
  }
};

export const socialLogin = (type, history) => async (dispatch) => {
  try {
    let response;

    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const fireBaseBackend = getFirebaseBackend();
      response = fireBaseBackend.socialLoginUser(type);
    }
    //  else {
      //   response = postSocialLogin(data);
      // }
      
      const socialdata = await response;
    if (socialdata) {
      sessionStorage.setItem("authUser", JSON.stringify(response));
      dispatch(loginSuccess(response));
      history('/dashboard')
    }

  } catch (error) {
    dispatch(apiError(error));
  }
};


export const resetLoginFlag = () => async (dispatch) =>{
  try {
    const response = dispatch(reset_login_flag());
    return response;
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const ProfileDetailThunk = (token) => async (dispatch) => {
  // console.log("token",token)
  try {
    let response;

    response = getProfileDetail(token);

    // console.log("response", response);
    var data = await response;
    dispatch(addPersistUserInfo(data));
    return data;
  } catch (error) {

    return error;
  }
};

export const ForgotPasswordThunk = (user, history) => async (dispatch) => {
  try {
    // console.log(
    //   "process.env.REACT_APP_API_BASE_URL",
    //   process.env.REACT_APP_API_BASE_URL,
    //   user
    // );
    let response;
    response = postForgotPassword(user);
    dispatch(loginRequest());
    var data = await response;
    // console.log("data", data);
    if (data?.code===200) {
      // console.log("here");
      sessionStorage.setItem("authUser", JSON.stringify(data));

      // console.log("here 2");
      var finallogin = JSON.stringify(user);
      finallogin = JSON.parse(finallogin);
      dispatch(loginSuccess(response));
      data = finallogin.data;
      // console.log("data 2 final login", data, finallogin);
      // if (finallogin.status === "success") {
      //   dispatch(loginSuccess(data));
      //   showToast("Login successful","success")
      //   history('/dashboard')
      // } else {
      //   dispatch(apiError(finallogin));
      //   showToast("Invalid Credentials","error")
      // }
      // dispatch(loginSuccess(data));
      // dispatch(addPersistLoginInfo(data));
      // showToast("Login successful", "success");
      
      // history("/dashboard");
    }
    // else{
    //   showToast("Invalid Credentials", "error");
    // }
    return response;
  } catch (error) {
    dispatch(apiError(error));
    showToast(error, "error");
    return error;
  }
};

// postUpdatePassword
export const UpdatePassword = ({user,token}) => async (dispatch) => {
  try {
    // console.log( "user, token",user,token);
    let response;
    response = postUpdatePassword(user,token);

    var data = await response;
    // console.log("data", data);
    if (data?.code===200) { 
      // showToast(data.message, "success");
    }
    else{
      showToast(data, "error");
    }
    return data;
  } catch (error) {
    showToast(error, "error");
    return error;
  }
};